'use client'

import { useEffect, useRef, useState } from 'react'
import { gaTrack, ttqTrack } from '@/utils/ga'

const AdsenseAd = ({ slot }: { slot: string }) => {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    // 仅在全局脚本未加载时初始化
    if (!window.adsbygoogle) {
      window.adsbygoogle = []
    }
    window.adsbygoogle.push({})

    const handleBlur = () => {
      const adIframe = document.querySelector('.adsContainer iframe')
      if (adIframe === document.activeElement) {
        gaTrack('native_click_manual')
        ttqTrack('AddToWishlist')
        setTimeout(() => window.focus(), 0)
      }
    }

    window.addEventListener('blur', handleBlur)

    return () => {
      window.removeEventListener('blur', handleBlur)
    }
  }, [slot])

  return (
    <div className="adsContainer" style={{ display: 'block' }} ref={ref}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-format="fluid"
        data-ad-layout-key="-6t+ed+2i-1n-4w"
        data-ad-client="ca-pub-8634104692242410"
        data-ad-slot={slot}
        // data-adtest="on"
      ></ins>
    </div>
  )
}

export default AdsenseAd
